import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Stack, TagsInput, Title } from "@mantine/core";
import { SvgIcon } from "@mui/material";
import { useMemo } from "react";
import { useUpdatePriorityAttributeMutation } from "../../graphql/graphql";
export const TagsList = ({ priorityAttributeId, icon, title, tags }) => {
    const [_, updatePriorityAttribute] = useUpdatePriorityAttributeMutation();
    const tagsList = useMemo(() => {
        return tags || [];
    }, [tags]);
    const handleTagChange = (value) => {
        if (!priorityAttributeId)
            return;
        updatePriorityAttribute({
            priorityAttributeId: priorityAttributeId,
            tags: value
        });
    };
    return (_jsxs(Stack, { variant: "outline", children: [_jsxs(Flex, { gap: "xs", align: "center", children: [_jsx(SvgIcon, { component: icon, style: {
                            width: "1rem",
                            color: "var(--mantine-color-gray-6)"
                        } }), _jsx(Title, { order: 5, children: title })] }), _jsx(TagsInput, { variant: "unstyled", placeholder: "Enter tags...", acceptValueOnBlur: true, splitChars: [","], style: {
                    color: "var(--mantine-color-black)",
                    borderRadius: "0.2rem",
                    fontSize: "0.8rem",
                    fontWeight: 500
                }, value: tagsList, onChange: (value) => handleTagChange(value) })] }));
};
